import(/* webpackMode: "eager" */ "/vercel/path0/app/ja/footnotes/page.tsx");
